import { createSelector } from 'reselect';

const getDisabledVideoAutoPlay = (state) => state?.config?.disabledVideoAutoPlay;
const getAppMute = (state) => state?.config?.appMute;
const getAppCaptions = (state) => state?.config?.appCaptions;

export const getAppVideoSettingPermission = createSelector(
    [ getDisabledVideoAutoPlay, getAppMute, getAppCaptions],
    ( disabledVideoAutoPlay, appMute, appCaptions) => ({
        disabledVideoAutoPlay, 
        appMute,
        appCaptions
    })
);
